<template>
  <div class="max-w-5xl mx-auto p-4">
    <h1 class="text-2xl font-bold mb-4">Awards Checklist — Test Films</h1>

    <ul class="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-x-3 gap-y-4 list-none p-0 my-4">
      <li v-for="film in normalizedFilms" :key="film.id" class="flex flex-col">
        <button
          type="button"
          class="group block w-full cursor-pointer border-0 bg-transparent p-0"
          @click="openFilm(film)"
        >
          <img
            v-if="film.posterUrl"
            :src="film.posterUrl"
            :alt="film.title"
            loading="lazy"
            class="block aspect-[2/3] w-full rounded-lg object-cover shadow-sm transition-transform duration-150 group-hover:scale-105"
          />
          <span
            v-else
            class="flex aspect-[2/3] w-full items-center justify-center rounded-lg bg-gray-200 p-2 text-center text-xs text-gray-600"
          >
            {{ film.title }}
          </span>
        </button>

        <h3 class="mt-1 mb-0.5 line-clamp-2 text-sm leading-tight">{{ film.title }}</h3>

        <JustWatchWidget v-if="film.tmdbId" :tmdb-id="film.tmdbId" compact />
      </li>
    </ul>

    <dialog
      ref="dialogRef"
      class="w-[90vw] max-w-md rounded-xl border-0 p-0 shadow-2xl backdrop:bg-black/50"
      @click="onBackdropClick"
      @close="selectedFilm = null"
    >
      <div v-if="selectedFilm" class="relative flex flex-col">
        <button
          type="button"
          class="absolute top-2 right-2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full border-0 bg-black/50 leading-none text-white"
          aria-label="Close"
          @click="closeModal"
        >
          ✕
        </button>

        <img
          v-if="selectedFilm.posterUrl"
          :src="selectedFilm.posterUrl"
          :alt="selectedFilm.title"
          class="max-h-[300px] w-full rounded-t-xl object-cover"
        />

        <div class="p-4">
          <h2 class="text-lg font-semibold">{{ selectedFilm.title }}</h2>
          <p class="mb-2 text-sm text-gray-600">{{ selectedFilm.releaseDate }}</p>
          <p class="mb-3 text-sm">{{ selectedFilm.overview }}</p>
          <p class="mb-3 text-xs text-gray-400">
            TMDB ID: {{ selectedFilm.tmdbId }} · OCL ID: {{ selectedFilm.oclId }}
          </p>

          <JustWatchWidget v-if="selectedFilm.tmdbId" :tmdb-id="selectedFilm.tmdbId" />
        </div>
      </div>
    </dialog>

    <WatchedFilmMatcher />
  </div>
</template>

<script setup>
const { data: films } = await useFetch('http://localhost:1337/api/films')

function normalizeFilm(film) {
  return {
    id: film.id,
    title: film.attributes?.title ?? film.title,
    overview: film.attributes?.overview ?? film.overview,
    releaseDate: film.attributes?.releaseDate ?? film.releaseDate,
    posterUrl: film.attributes?.posterUrl ?? film.posterUrl,
    tmdbId: film.attributes?.tmdbId ?? film.tmdbId,
    oclId: film.attributes?.oclId ?? film.oclId
  }
}

const normalizedFilms = computed(() => (films.value?.data ?? []).map(normalizeFilm))

const dialogRef = ref(null)
const selectedFilm = ref(null)

function openFilm(film) {
  selectedFilm.value = film
  dialogRef.value?.showModal()
}

function closeModal() {
  dialogRef.value?.close()
}

function onBackdropClick(event) {
  if (event.target === dialogRef.value) {
    closeModal()
  }
}
</script>